import { render } from "./base-grid.vue?vue&type=template&id=78da91b4&ts=true"
import script from "./base-grid.vue?vue&type=script&lang=ts"
export * from "./base-grid.vue?vue&type=script&lang=ts"

import "./base-grid.vue?vue&type=style&index=0&id=78da91b4&lang=scss"

import exportComponent from "/srv/loq/temp/Admin-Web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__